module.exports = new __parcel__URL__("reise-reise.25dd0066.jpg").toString();